import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { IoIosArrowForward } from "react-icons/io";
import { GoDownload, GoPeople } from "react-icons/go";
import { CiCalendar, CiFilter, CiTimer } from "react-icons/ci";
import { Avatar } from "@mui/material";
import { FaArrowTrendUp, FaIndianRupeeSign } from "react-icons/fa6";
import { IoPersonOutline } from "react-icons/io5";
import useCommission from "./hooks/useCommission";
import Paginations from "../../../Components/Pagination/pagination";

const Commission = () => {
  const navigate = useNavigate();
  const [showFilters, setShowFilters] = useState(false);
  const { data, method } = useCommission();
  const {
    commissionByStructureList,
    activeTab,
    filter,
    byTeamList,
    commGroupList,
    searchParams,
  } = data;
  const {
    setActiveTab,
    handleChangeFilter,
    resetFilters,
    commissionListAPI,
    ByTeamMemberDashboardListAPI,
    commissionGroupDashboard,
    handleDownloadAll,
  } = method;

  useEffect(() => {
    if (activeTab === "structure") commissionListAPI();
    if (activeTab === "member") ByTeamMemberDashboardListAPI();
    if (activeTab === "group") commissionGroupDashboard();
  }, [activeTab, filter.days, filter.modelType, filter.assignTo]);

  const currencySymbol = "₹";

  const TabButton = ({ id, label, icon }) => {
    const isActive = activeTab === id;

    return (
      <button
        type="button"
        onClick={() => setActiveTab(id)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: "8px 14px",
          borderRadius: "10px",
          border: isActive ? "1px solid #ED8F80" : "1px solid #D1D5DB",
          background: isActive ? "#FFF5F0" : "#FFFFFF",
          color: isActive ? "#ED8F80" : "#374151",
          fontWeight: 500,
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        {icon}
        {label}
      </button>
    );
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-GB");
  };
  const formatMonthYear = (dateValue) => {
    if (!dateValue) return "-";

    const date = dateValue instanceof Date ? dateValue : new Date(dateValue);

    if (isNaN(date.getTime())) return "-";

    return date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
      timeZone: "UTC", // prevents Nov → Dec shift
    });
  };

  return (
    <section>
      <ToastContainer />
      <div className="m-t-3 cus-padd cusheight">
        <header>
          <div className="d-flex justify-content-between">
            <h2 className="page-tittle">
              <i
                className="fa-solid fa-angle-left cusgap cursor"
                onClick={() => navigate(-1)}
              />
              Commission Dashboard
            </h2>
            <div className="d-flex gap-2 align-items-center">
              <button
                className="btn d-flex align-items-center gap-2"
                onClick={() => setShowFilters(!showFilters)}
                style={{
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  background: "#fff",
                  fontSize: "14px",
                  padding: "10px 14px",
                  fontWeight: 500,
                }}
              >
                <CiFilter fontSize={18} />
                Filters
              </button>
              <button onClick={handleDownloadAll}
                className="btn px-4"
                style={{
                  background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                  color: "#FFF",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  paddingBlock: "10px",
                }}
              >
                <GoDownload fontSize={18} style={{ marginRight: "6px" }} />
                Download All
              </button>
            </div>
          </div>
          <hr />
        </header>

        <div className="mb-4 d-flex gap-2">
          <TabButton
            id="structure"
            label="By Structure"
            icon={<FaArrowTrendUp size={16} />}
          />

          <TabButton
            id="member"
            label="By Team Member"
            icon={<IoPersonOutline size={16} />}
          />

          <TabButton
            id="group"
            label="By Group"
            icon={<GoPeople size={16} />}
          />
        </div>

        {/* Filters */}

        {showFilters && (
          <div
            className="shadow-sm mb-4"
            style={{
              borderRadius: "14px",
              background: "#fff",
              padding: "16px 18px",
            }}
          >
            <div className="d-flex justify-content-between align-items-center mb-2">
              <h6 style={{ margin: 0, fontWeight: 600 }}>Filters</h6>
              <i
                className="fa-solid fa-xmark cursor"
                onClick={() => setShowFilters(false)}
              />
            </div>

            <div className="row g-3 align-items-end">
              <div className="col-md-3">
                <label className="form-label">Days</label>
                <select
                  className="form-select"
                  name="days"
                  value={filter.days}
                  onChange={handleChangeFilter}
                >
                  <option value="TODAY">Today</option>
                  <option value="THIS_MONTH">This Month</option>
                  <option value="LAST_MONTH">Last Month</option>
                  <option value="THIS_YEAR">This Year</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label">Structure Type</label>
                <select
                  className="form-select"
                  name="modelType"
                  value={filter.modelType}
                  onChange={handleChangeFilter}
                >
                  <option value="">All Types</option>
                  <option value="TARGET_BASED">Target Based</option>
                  <option value="ITEM_BASED">Item Based</option>
                </select>
              </div>

              <div className="col-md-3">
                <label className="form-label">Assignment Type</label>
                <select
                  className="form-select"
                  name="assignTo"
                  value={filter.assignTo}
                  onChange={handleChangeFilter}
                >
                  <option value="">All Assignments</option>
                  <option value="GROUP">Group</option>
                  <option value="STAFF">Staff</option>
                </select>
              </div>
              <div className="col-md-3">
              {/* <button
                onClick={resetFilters}
                className="btn"
                style={{
                  border: "1px solid #D1D5DB",
                  borderRadius: "8px",
                  background: "#fff",
                }}
              >
                Reset Filters
              </button> */}
                            <button onClick={resetFilters}
                className="btn px-4"
                style={{
                  background: "linear-gradient(to right, #EA8F80, #F09A8B)",
                  color: "#FFF",
                  border: "none",
                  borderRadius: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  paddingBlock: "10px",
                }}
              >
                Reset Filters
              </button>
            </div>
            </div>


          </div>
        )}

        {activeTab === "structure" && (
          <div>
      <div className="row mb-4 align-items-stretch">
  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Total Commissions</small>
        <FaIndianRupeeSign color="#1FD065" />
      </div>

      <h4 className="mt-1">
        {currencySymbol}
        {commissionByStructureList?.totalCommission}
      </h4>

      <small className="text-success">↑ {commissionByStructureList?.growthPercentage}% from last month</small>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Active Structures</small>
        <FaArrowTrendUp color="#2B7FFF" />
      </div>

      <h4 className="mt-1">
        {commissionByStructureList?.activeStructures}
      </h4>

      <small className="text-success">Commission structures</small>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">This Month</small>
        <CiCalendar color="#EE9586" />
      </div>

      <small>
        {formatDate(commissionByStructureList?.monthLabel?.startDate)} -{" "}
        {formatDate(commissionByStructureList?.monthLabel?.endDate)}
      </small>

      <small className="text-success d-block mt-1">Current period</small>
    </div>
  </div>
</div>


            <div className="shadow-sm" style={{ borderRadius: 14 }}>
              <div className="card-body">
                <h6 className="pt-3 px-3">Commission Structures</h6>
                <hr />
                <div style={{maxHeight:'500px', overflow:'auto'}}>
                {commissionByStructureList?.commissionByStructure?.map(
                  (item, i) => (
                    <div
                      onClick={() =>
                        navigate(
                          `/layout/insightList/commission/by-structure-details/${
                            item?._id
                          }/${item?.groupId}?${searchParams.toString()}`
                        )
                      }
                      key={item._id}
                      className="d-flex justify-content-between align-items-start"
                      style={{
                        background: "#fff",
                        padding: "5px 18px",
                        borderBottom: "1px solid #C7C8C9",
                        cursor: "pointer",
                      }}
                    >
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-1">
                          <span
                            style={{
                              margin: 0,
                              fontWeight: 600,
                              fontSize: "15px",
                            }}
                          >
                            {item?.structureName}
                          </span>

                          <span
                            style={{
                              fontSize: "11px",
                              padding: "4px 10px",
                              borderRadius: "20px",
                              background:
                                item?.modelType === "TARGET_BASED"
                                  ? "#EAF1FF"
                                  : "#F3E8FF",
                              color:
                                item?.modelType === "TARGET_BASED"
                                  ? "#2563EB"
                                  : "#7C3AED",
                              fontWeight: 500,
                            }}
                          >
                            {item?.modelType === "TARGET_BASED"
                              ? "Target Based"
                              : "Item Based"}
                          </span>
                        </div>
                        <div className="d-flex align-items-center gap-3">
                          <div className="d-flex align-items-center gap-1">
                            <GoPeople />
                            <p
                              style={{
                                margin: "4px 0",
                                fontSize: "14px",
                                color: "#555",
                              }}
                            >
                              {item?.structureName} ({item?.groupSize})
                            </p>
                          </div>

                          <div>
                            {(item?.validFrom || item?.validTo) && (
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "13px",
                                  color: "#777",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                }}
                              >
                                <i className="fa-regular fa-calendar" />

                                {item?.validFrom &&
                                  ` ${formatDate(item.validFrom)}`}
                                {item?.validTo &&
                                  ` - ${formatDate(item.validTo)}`}
                              </p>
                            )}
                          </div>
                        </div>
                        <p
                          style={{
                            margin: "4px 0",
                            fontSize: "14px",
                            color: "#555",
                          }}
                        >
                          Assigned to: {item?.assignTo}
                        </p>
                      </div>

                      {/* Actions */}
                      <div className="d-flex align-items-center gap-2">
                        <div>
                          <div>
                            {currencySymbol}
                            {item?.totalCommission}{" "}
                          </div>
                          <span style={{ fontSize: "12px" }}>
                            Total commission
                          </span>
                        </div>
                        <IoIosArrowForward
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            navigate(
                              `/layout/insightList/commission/by-structure-details/${
                                item?._id
                              }/${item?.groupId}?${searchParams.toString()}`
                            )
                          }
                        />
                      </div>
                    </div>
                  )
                )}
                </div>

              </div>
              {commissionByStructureList?.commissionByStructure?.length ===
                0 && (
                <div className="card-body py-3">
                  <p className="text-center text-muted mb-0">
                    No data available
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
        {/* -------- TEAM MEMBER -------- */}
        {activeTab === "member" && (
          <div>
      <div className="row mb-4 align-items-stretch">
  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Total Commissions</small>
        <FaIndianRupeeSign color="#1FD065" />
      </div>

      <h4 className="mt-1">
        {currencySymbol}
        {byTeamList?.cards?.totalCommissions}
      </h4>

      {/* <small className="text-success">↑ 12% from last month</small> */}
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Team Member</small>
        <FaArrowTrendUp color="#2B7FFF" />
      </div>

      <h4 className="mt-1">
        {byTeamList?.cards?.teamMembers}
      </h4>

      {/* <small className="text-success">Active members</small> */}
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">This Month</small>
        <CiCalendar color="#EE9586" />
      </div>

      <small>
        {formatDate(byTeamList?.cards?.monthLabel?.startDate)} -{" "}
        {formatDate(byTeamList?.cards?.monthLabel?.endDate)}
      </small>

      <small className="text-success d-block mt-1">
        Current period
      </small>
    </div>
  </div>
     </div>

            <div className="shadow-sm" style={{ borderRadius: 14 }}>
              <div className="card-body">
                <h6 className="pt-3 px-3">Team Member Commission History</h6>
                <hr />
                 <div style={{maxHeight:'500px', overflow:'auto'}}>
                {byTeamList?.list?.map((item, i) => (
                  <div
                    onClick={() =>
                      navigate(
                        `/layout/insightList/commission/team-member/history/${
                          item?.staffId
                        }?${searchParams.toString()}`
                      )
                    }
                    key={item?.staffId}
                    className="d-flex justify-content-between align-items-start"
                    style={{
                      background: "#fff",
                      padding: "5px 18px",
                      borderBottom: "1px solid #C7C8C9",
                      cursor: "pointer",
                    }}
                  >
                    {/* Left Content */}
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <Avatar
                          alt="Remy Sharp"
                          src="/static/images/avatar/1.jpg"
                        />
                        <div>
                          <span
                            style={{
                              margin: 0,
                              fontWeight: 600,
                              fontSize: "15px",
                            }}
                          >
                            {item?.staffName}
                          </span>

                          <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center gap-1">
                              <CiTimer />
                              <p
                                style={{
                                  margin: "4px 0",
                                  fontSize: "14px",
                                  color: "#555",
                                }}
                              >
                                {item?.assignmentPeriods} assignment periods
                              </p>
                            </div>
                            <div>
                              {item?.since && (
                                <p
                                  style={{
                                    margin: 0,
                                    fontSize: "13px",
                                    color: "#777",
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "6px",
                                  }}
                                >
                                  <i className="fa-regular fa-calendar" />

                                  {formatDate(item?.since)}
                                </p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex align-items-center gap-2">
                      <div>
                        <div>
                          {currencySymbol}
                          {item?.totalEarned}{" "}
                        </div>
                        <span style={{ fontSize: "12px" }}>Total Earned</span>
                      </div>
                      <IoIosArrowForward
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(
                            `/layout/insightList/commission/team-member/history/${
                              item?.staffId
                            }?${searchParams.toString()}`
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
                 </div>
              </div>
              {byTeamList?.list?.length === 0 && (
                <div className="card-body py-3">
                  <p className="text-center text-muted mb-0">
                    No data available
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        {/* -------- GROUP -------- */}
        {activeTab === "group" && (
          <div>
       <div className="row mb-4 align-items-stretch">
  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Total Commissions</small>
        <FaIndianRupeeSign color="#1FD065" />
      </div>

      <h4 className="mt-1">
        {currencySymbol}
        {commGroupList?.summary?.totalCommission}
      </h4>

      <small className="text-success">↑ {commGroupList?.summary?.growthPercentage}% from last month</small>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">Groups</small>
        <FaArrowTrendUp color="#2B7FFF" />
      </div>

      <h4 className="mt-1">
        {commGroupList?.summary?.groupsCount}
      </h4>

      <small className="text-success">Commission groups</small>
    </div>
  </div>

  <div className="col-md-4 d-flex">
    <div className="shadow-sm p-3 w-100 h-100" style={{ borderRadius: 12 }}>
      <div className="d-flex justify-content-between align-items-center">
        <small className="text-muted">This Month</small>
        <CiCalendar color="#EE9586" />
      </div>

      <small>
        {formatDate(commGroupList?.summary?.monthLabel?.startDate)} -{" "}
        {formatDate(commGroupList?.summary?.monthLabel?.endDate)}
      </small>

      <small className="text-success d-block mt-1">
        Current period
      </small>
    </div>
  </div>
</div>

            <div className="shadow-sm" style={{ borderRadius: 14 }}>
              <div className="card-body">
                <h6 className="pt-3 px-3">Group Commission History</h6>
                <hr />
                 <div style={{maxHeight:'500px', overflow:'auto'}}>
                {commGroupList?.groups?.map((item, i) => (
                  <div
                    onClick={() =>
                      navigate(
                        `/layout/insightList/commission/group-details/${
                          item?._id
                        }?${searchParams.toString()}`
                      )
                    }
                    key={item?.groupId}
                    className="d-flex justify-content-between align-items-start"
                    style={{
                      background: "#fff",
                      padding: "5px 18px",
                      borderBottom: "1px solid #C7C8C9",
                      cursor: "pointer",
                    }}
                  >
                    {/* Left Content */}
                    <div>
                      <div className="d-flex align-items-center gap-2 mb-1">
                        <Avatar
                          alt="Remy Sharp"
                          src="/static/images/avatar/1.jpg"
                        />
                        <div>
                          <span
                            style={{
                              margin: 0,
                              fontWeight: 600,
                              fontSize: "15px",
                            }}
                          >
                            {item?.groupName}
                          </span>
                          <div className="d-flex align-items-center gap-3">
                            <div className="d-flex align-items-center gap-3">
                              <div className="d-flex align-items-center gap-1">
                                <CiTimer />
                                <p
                                  style={{
                                    margin: "4px 0",
                                    fontSize: "14px",
                                    color: "#555",
                                  }}
                                >
                                  {item?.currentMembers} current members
                                </p>
                              </div>
                              <div className="d-flex align-items-center gap-1">
                                <CiTimer />
                                <p
                                  style={{
                                    margin: "4px 0",
                                    fontSize: "14px",
                                    color: "#555",
                                  }}
                                >
                                  {item?.totalMembers} total members
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="d-flex align-items-center gap-2">
                      <div>
                        <div>
                          {currencySymbol}
                          {item?.totalEarned}{" "}
                        </div>
                        <span style={{ fontSize: "12px" }}> Total Earned</span>
                      </div>
                      <IoIosArrowForward
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate(
                            `/layout/insightList/commission/group-details/${
                              item?._id
                            }?${searchParams.toString()}`
                          )
                        }
                      />
                    </div>
                  </div>
                ))}
                 </div>
              </div>
              {commGroupList?.groups?.length === 0 && (
                <div className="card-body py-3">
                  <p className="text-center text-muted mb-0">
                    No data available
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Commission;
